/* eslint-disable no-trailing-spaces */
/* eslint-disable indent */
/** 当路由表太长时，可以将其拆分为小模块 **/

import Layout from '@/layout'

const homeRouter = {
  path: '/home',
  component: Layout,
  redirect: 'noRedirect',
  name: 'home',
  meta: {
    title: '产品追溯系统',
    icon: 'tree-table'
  },
  children: [
    // 生产管理
    {
      path: 'plant',
      component: () => import('@/views/home/first'),
      name: 'plant',
      meta: {title: '生产管理', icon: 'list', roles: ['plant']},
      children: [
        {
          path: 'plantinfo',
          component: () => import('@/views/home/second'),
          name: 'plantinfo',
          meta: {title: '工厂信息', roles: ['plantinfo']},
          children: [
            {
              path: 'plantmanage',
              component: () => import('@/views/home/third'),
              name: 'plantmanage',
              meta: {title: '工厂管理', roles: ['plantmanage']},
              children: [
                {
                  path: 'plantlist',
                  component: () => import('@/views/home/plant/plantinfo/plantlist'),
                  name: 'plantlist',
                  meta: {noCache: true, title: '工厂列表', roles: ['plantlist']}
                },
                {
                  path: '/workshoplist',
                  component: () => import('@/views/home/plant/plantinfo/workshoplist'),
                  name: 'workshoplist',
                  meta: {title: '车间列表', roles: ['workshoplist'], noCache: true}
                },
                {
                  path: '/workline',
                  component: () => import('@/views/home/plant/plantinfo/workline'),
                  name: 'workline',
                  meta: {title: '产线列表', roles: ['workline'], noCache: true}
                }
              ]
            },
            {
              path: 'classlist',
              component: () => import('@/views/home/plant/plantinfo/classlist'),
              name: 'classlist',
              meta: {title: '班组管理', roles: ['classlist']}
            }
          ]
        },
        {
          path: 'production',
          component: () => import('@/views/home/second'),
          name: 'production',
          meta: {title: '生产信息', roles: ['production']},
          children: [
            {
              path: '/orderPlus',
              component: () => import('@/views/home/plant/production/order/orderPlus'),
              name: 'orderPlus',
              meta: {title: '生产加工单', roles: ['orderPlus']}
            },
            {
              path: '/orderSubtask',
              component: () => import('@/views/home/plant/production/order/orderSubtask'),
              name: 'orderSubtask',
              meta: {title: '生产子加工单', roles: ['orderSubtask']}
            },
            {
              path: '/orderlist',
              component: () => import('@/views/home/plant/production/order/orderlist'),
              name: 'orderlist',
              meta: {title: '生产批次加工单', roles: ['orderlist']}
            },
            {
              path: '/receipt',
              component: () => import('@/views/home/plant/production/order/receipt'),
              name: 'receipt',
              meta: {title: '生产入库', roles: ['receipt']}
            },
            {
              path: '/receiptScan',
              component: () => import('@/views/home/plant/production/order/receiptScan'),
              name: 'receiptScan',
              meta: {title: '生产扫码记录', roles: ['receiptScan']}
            },
            {
              path: '/relevance',
              component: () => import('@/views/home/plant/production/relevance'),
              name: 'relevance',
              meta: {title: '包装关联', roles: ['relevance']}
            },
            {
              path: '/unrelevance1',
              component: () => import('@/views/home/plant/production/unrelevance1'),
              name: 'unrelevance1',
              meta: {title: '关联解除', roles: ['unrelevance1']}
            },
            {
              path: 'replace',
              component: () => import('@/views/home/plant/production/replace'),
              name: 'replace',
              meta: {title: '关联替换', roles: ['replace']}
            },
            {
              path: '/taskmanagement',
              component: () => import('@/views/home/plant/production/taskmanagement'),
              name: 'taskmanagement',
              meta: {title: '任务管理', roles: ['taskmanagement']}
            },
            {
              path: '/materialquery',
              component: () => import('@/views/home/plant/production/materialquery/materialquery'),
              name: 'materialquery',
              meta: {title: '原料投料管理', roles: ['materialquery']}
            },
            {
              path: '/repeatedquery',
              component: () => import('@/views/home/plant/production/repeatedquery'),
              name: 'repeatedquery',
              meta: {title: '重码查询', roles: ['repeatedquery']}
            },
            {
              path: '/harvestrate',
              component: () => import('@/views/home/plant/production/harvestrate'),
              name: 'harvestrate',
              meta: {title: '工单采集率', roles: ['harvestrate']}
            },
            {
              path: '/orderextendlist',
              hidden: true,
              component: () => import('@/views/home/plant/production/orderextendlist/orderextendlist'),
              name: 'orderextendlist',
              meta: {title: '工单扩展属性'}
            },
          ]
        }
      ]
    },
    {
      path: '/physical',
      component: () => import('@/views/home/first'),
      name: 'physical',
      redirect: 'noRedirect',
      meta: {title: '工厂物流', icon: 'table', roles: ['physical']},
      children: [
        {
          path: 'shipments',
          component: () => import('@/views/home/second'),
          name: 'shipments',
          redirect: 'noRedirect',
          meta: {title: '工厂发货', roles: ['shipmentsmanage']},
          children: [
            {
              path: '/freight',
              component: () => import('@/views/home/physical/shipments/freight'),
              name: 'freight',
              meta: {title: '运单管理', roles: ['freight']}
            },
            {
              path: '/boxcode',
              component: () => import('@/views/home/physical/shipments/boxcode'),
              name: 'boxcode',
              meta: {title: '箱码查询', roles: ['boxcode']}
            },
            {
              path: '/Minderlieferung',
              component: () => import('@/views/home/physical/shipments/Minderlieferung'),
              name: 'Minderlieferung',
              meta: {title: '减货查询', roles: ['Minderlieferung']}
            },
            {
              path: '/barter',
              component: () => import('@/views/home/physical/shipments/barter'),
              name: 'barter',
              meta: {title: '换货查询', roles: ['barter']}
            },
            {
              path: '/RDCdissociated',
              component: () => import('@/views/home/physical/shipments/RDCdissociated'),
              name: 'RDCdissociated',
              meta: {title: '解除运单关联', roles: ['RDCdissociated']}
            },
            {
              path: '/xiazai',
              component: () => import('@/views/home/xiazai.vue'),
              name: 'xiazai',
              meta: {title: '上传/下载', roles: ['xiazai']}
            },
            {
              path: '/loglist',
              component: () => import('@/views/home/physical/shipments/loglist'),
              name: 'loglist',
              meta: {title: 'WMS出库异常日志', roles: ['loglist']}
            },
            {
              path: '/findDirection',
              component: () => import('@/views/home/physical/shipments/findDirection'),
              name: 'findDirection',
              meta: {title: '批次流向查询', roles: ['findDirection']}
            },
          ]
        },
        {
          path: 'salesreturn',
          component: () => import('@/views/home/second'),
          name: 'salesreturn',
          redirect: 'noRedirect',
          meta: {title: '工厂退货', roles: ['salesreturn']},
          children: [
            {
              path: '/refund',
              component: () => import('@/views/home/physical/dealerrefund/index'),
              name: 'refund',
              meta: {title: '退货日志', roles: ['refund']}
            },
            {
              path: '/returngoodsorders',
              component: () => import('@/views/home/physical/salesreturn/returngoodsorders'),
              name: 'returngoodsorders',
              meta: {title: '退货查询', roles: ['returngoodsorders']}
            },
            {
              path: '/dissociated',
              component: () => import('@/views/home/physical/salesreturn/dissociated'),
              name: 'dissociated',
              meta: {title: '解除运单关联', roles: ['dissociated']}
            },
            // {
            //   path: '/deliveryorder',
            //   component: () => import('@/views/home/physical/salesreturn/deliveryorder'),
            //   name: 'deliveryorder',
            //   meta: { title: '生产数据异常', roles: ['deliveryorder'] }
            // }
          ],

        },
        {
          path: 'transferOutOrderList',
          component: () => import('@/views/home/second'),
          name: 'transferOutOrderList',
          redirect: 'noRedirect',
          meta: {title: '调拨出库', roles: ['salesreturn']},
          children: [
            {
              path: '/transferOutOrder',
              component: () => import('@/views/home/plant/production/order/transferOutOrder'),
              name: 'transferOutOrder',
              meta: {title: '调拨记录', roles: ['salesreturn']}
            },
            {
              path: '/transferOutOrderScan',
              component: () => import('@/views/home/plant/production/order/transferOutOrderScan'),
              name: 'transferOutOrderScan',
              meta: {title: '调拨扫码记录', roles: ['salesreturn']}
            },
          ],
        },
      ]
    },
    // 渠道物流
    {
      path: '/channelphysical',
      component: () => import('@/views/home/first'),
      name: 'channelphysical',
      redirect: 'noRedirect',
      meta: {title: '渠道物流', icon: 'table', roles: ['channelphysical']},
      children: [
        {
          path: 'dealerphysical',
          component: () => import('@/views/home/second'),
          name: 'dealerphysical',
          redirect: 'noRedirect',
          meta: {title: '经销商物流', roles: ['dealerphysical']},
          children: [
            {
              path: 'dealersignorder',
              component: () => import('@/views/home/second'),
              name: 'dealersignorder',
              redirect: 'noRedirect',
              meta: {title: '经销商签收', roles: ['tsdealersignorder']},
              children: [
                {
                  path: '/dealersignorderlogs',
                  component: () => import('@/views/home/channelphysical/dealerphysical/dealersignorder/dealersignorderlogs'),
                  name: 'dealersignorderlogs',
                  meta: {title: '签收记录', roles: ['tsdealersignorderlogs']}
                },
                {
                  path: '/dealersignqrcodescanlog',
                  component: () => import('@/views/home/channelphysical/dealerphysical/dealersignorder/dealersignqrcodescanlog'),
                  name: 'dealersignqrcodescanlog',
                  meta: {title: '签收扫码异常记录', roles: ['tsdealersignqrcodescanlog']}
                },
              ]
            },
            {
              path: '/tssttSsignWeblist',
              component: () => import('@/views/home/channelphysical/dealerphysical/sttSsignWeblist'),
              name: 'tssttSsignWeblist',
              meta: {title: '经销商出库', roles: ['tssttSsignWeblist']},
            },
            {
              path: '/refundorderlist',
              component: () => import('@/views/home/channelphysical/dealerphysical/refundorderlist'),
              name: 'refundorderlist',
              meta: {title: '终端退货记录', roles: ['tsrefundorderlist']},
            },
            // {
            //   path: '/sttsdealerlogs',
            //   component: () => import('@/views/home/channelphysical/dealerphysical/sttsdealerlogs'),
            //   name: 'sttsdealerlogs',
            //   meta: { title: '经销商报表', roles: ['tssttSsignWeblist'] },
            // },
          ]
        },
        {
          path: 'terminalphysical',
          component: () => import('@/views/home/second'),
          name: 'terminalphysical',
          redirect: 'noRedirect',
          meta: {title: '终端物流', roles: ['terminalphysical']},
          children: [
            {
              path: '/sttSsignWeblist',
              component: () => import('@/views/home/channelphysical/terminalphysical/sttSsignWeblist'),
              name: 'sttSsignWeblist',
              meta: {title: '单据签收记录', roles: ['TsttSsignWeblist']},
            },
            {
              path: '/sttSsignscancodelogs',
              component: () => import('@/views/home/channelphysical/terminalphysical/sttSsignscancodelogs'),
              name: 'sttSsignscancodelogs',
              meta: {title: '扫码签收记录', roles: ['sttSsignscancodelogs']},
            },

          ]
        },
        {
          path: 'channelinventory',
          component: () => import('@/views/home/second'),
          name: 'channelinventory',
          redirect: 'noRedirect',
          meta: {title: '渠道库存', roles: ['channelinventory']},
          children: [
            {
              path: '/channelinventorylist',
              component: () => import('@/views/home/channelphysical/channelinventory/channelinventorylist'),
              name: 'channelinventorylist',
              meta: {title: '渠道库存列表', roles: ['channelinventorylist']},
            },
            {
              path: '/channelinventorylogs',
              component: () => import('@/views/home/channelphysical/channelinventory/channelinventorylogs'),
              name: 'channelinventorylogs',
              meta: {title: '渠道库存流水', roles: ['channelinventorylogs']},
            },

          ]
        },
      ]
    },

    // 稽查管理
    {
      path: '/inspect',
      component: () => import('@/views/home/first'),
      name: 'inspect',
      redirect: 'noRedirect',
      meta: {title: '稽查管理', icon: 'table', roles: ['inspect']},
      children: [
        {
          path: '/forensics',
          component: () => import('@/views/home/inspect/forensics'),
          name: 'forensics',
          meta: {title: '取证记录', roles: ['forensics']}
        },
        {
          path: '/inspectrecord',
          component: () => import('@/views/home/inspect/inspectrecord'),
          name: 'inspectrecord',
          meta: {title: '稽查记录', roles: ['inspectrecord']}
        }, {
          path: '/qrcodescaninspectleveltwo',
          component: () => import('@/views/home/inspect/qrcodescaninspectleveltwo'),
          name: 'qrcodescaninspectleveltwo',
          meta: {title: '窜货记录', roles: ['qrcodescaninspectleveltwo']}
        },
        {
          path: '/queryconsumerwarning',
          component: () => import('@/views/home/inspect/queryconsumerwarning'),
          name: 'queryconsumerwarning',
          meta: {title: '预警清单', roles: ['queryconsumerwarning']}
        },
        {
          path: '/warningparam',
          component: () => import('@/views/home/inspect/warningparam'),
          name: 'warningparam',
          meta: {title: '配置预警参数', roles: ['warningparam']}
        },
        {
          path: '/informationinquiry',
          component: () => import('@/views/home/inspect/informationinquiry'),
          name: 'informationinquiry',
          meta: {title: '信息查询', roles: ['informationinquiry']}
        },

      ]
    },
    // 查询管理
    {
      path: '/querymanage',
      component: () => import('@/views/home/first'),
      name: 'querymanage',
      redirect: 'noRedirect',
      meta: {title: '查询管理', icon: 'table', roles: ['querymanage']},
      children: [
        {
          path: '/customerinquire',
          component: () => import('@/views/home/query/customerinquire'),
          name: 'customerinquire',
          meta: {title: '消费者查询页', roles: ['customerinquire']}
        },
        {
          path: '/customerquery',
          component: () => import('@/views/home/query/customerquery'),
          name: 'customerquery',
          meta: {title: '消费者查询记录', roles: ['customerquery']}
        },
        {
          path: '/scadacollectstat',
          component: () => import('@/views/home/query/scadacollectstat'),
          name: 'scadacollectstat',
          // meta: { title: '采集统计', roles: ['scadacollectstat'] }
          meta: { title: '采集统计'}
        },
        {
          path: '/scancode',
          component: () => import('@/views/home/query/scancode/scancode'),
          name: 'scancode',
          meta: {title: '扫码模板管理', roles: ['scancode']},
        },
        {
          path: '/yyscancode',
          component: () => import('@/views/home/query/yyscancode/yyscancode'),
          name: 'yyscancode',
          meta: {title: '模板轮播图', roles: ['yyscancode']},
        },
        {
          path: '/dragpagetemplate',
          component: () => import('@/views/dragpage'),
          name: 'dragpagetemplate',
          meta: {title: 'h5扫码页面模板', roles: ['dragpagetemplate']}
        },
        {
          path: '/dragpage',
          component: () => import('@/views/dragpage/page'),
          name: 'dragpage',
          hidden: true,
          meta: {title: 'h5扫码页面自定义'}
        },
        {
          path: '/qrcodelifecycle',
          component: () => import('@/views/home/plant/production/qrcodelifecycle'),
          name: 'qrcodelifecycle',
          meta: {title: '码生命周期', roles: ['customerinquire']}
        },
      ]
    }, {
      path: '/board',
      component: () => import('@/views/home/first'),
      name: 'board',
      redirect: 'noRedirect',
      // meta: {title: '看板', icon: 'table'},
      meta: { title: '看板', icon: 'table', roles: ['board'] },
      children: [
        {
          path: '/dashboardOverview',
          component: () => import('@/views/home/board/dashboardOverview/dashboardOverview'),
          name: 'dashboardOverview',
          // meta: { title: '总览首页', roles: ['dashboardOverview'] }
          meta: {title: '总览首页'}
        },
        {
          path: '/productionMonitoring',
          component: () => import('@/views/home/board/productionMonitoring/productionMonitoring'),
          name: 'productionMonitoring',
          // meta: { title: '总览首页', roles: ['dashboardOverview'] }
          meta: {title: '生产监控'}
        },
        {
          path: '/scada-dashboard',
          component: () => import('@/views/scada-dashboard/index'),
          name: 'ScadaDashboard',
          // meta: { title: '总览首页', roles: ['dashboardOverview'] }
          meta: { title: 'SCADA'}
        },
        {
          path: '/warehouselogistics',
          component: () => import('@/views/home/board/warehouselogistics/warehouseLogistics'),
          name: 'warehouselogistics',
          // meta: { title: '总览首页', roles: ['dashboardOverview'] }
          meta: {title: '仓储物流'}
        },
        {
          path: '/inspectionManagement',
          component: () => import('@/views/home/board/inspectionManagement/inspectionManagement'),
          name: 'inspectionManagement',
          // meta: { title: '总览首页', roles: ['dashboardOverview'] }
          meta: {title: '稽查管理'}
        },
      ]
    },
    // // 日志管理
    // {
    //   path: '/logmanage',
    //   component: () => import('@/views/home/first'),
    //   name: 'logmanage',
    //   redirect: 'noRedirect',
    //   meta: { title: '日志管理', icon: 'table' },
    //   children: [
    //     {
    //       path: '/integrationlog',
    //       component: () => import('@/views/home/log/integrationlog'),
    //       name: 'integrationlog',
    //       meta: { title: '系统对接' }
    //     }
    //   ]
    // },
    // 报表管理板块
    // {
    //   path: 'report',
    //   component: () => import('@/views/home/first'),
    //   name: 'report',
    //   redirect: 'noRedirect',
    //   meta: { title: '报表管理', icon: 'table', roles: ['report'] },
    //   children: [
    //     {
    //       path: '/productionreport',
    //       component: () => import('@/views/home/second'),
    //       name: 'productionreport',
    //       meta: { title: '生产报表', roles: ['productionreport'] },
    //       children: [
    //         {
    //           path: '/collect',
    //           component: () => import('@/views/home/report/collect'),
    //           name: 'collect',
    //           meta: { title: '汇总报表', roles: ['collect'] }
    //         },
    //         {
    //           path: '/dateyield',
    //           component: () => import('@/views/home/report/dateyield'),
    //           name: 'dateyield',
    //           meta: { title: '日生产报表', roles: ['dateyield'] }
    //         },
    //         {
    //           path: '/productionorder',
    //           component: () => import('@/views/home/report/productionorder'),
    //           name: 'productionorder',
    //           meta: { title: '生产订单统计', roles: ['productionorder'] }
    //         }
    //       ]
    //     },
    //     {
    //       path: '/logistics',
    //       component: () => import('@/views/home/second'),
    //       name: 'logistics',
    //       meta: { title: '物流报表', roles: ['logistics'] },
    //       children: [
    //         // {
    //         //   path: '/shipments',
    //         //   component: () => import('@/views/home/report/shipments'),
    //         //   name: 'shipments',
    //         //   meta: { title: '仓库发货端', roles: ['shipments'] }
    //         // },
    //         {
    //           path: '/phoenix',
    //           component: () => import('@/views/home/report/phoenix'),
    //           name: 'phoenix',
    //           meta: { title: '退货报表', roles: ['phoenix'] }
    //         }
    //       ]
    //     }
    //   ]
    // }
  ]
}

export default homeRouter
